export default __webpack_public_path__ + "static/media/DSCN6159 (1).6bda8548.jpg";